'use client'

import { MOBILE_MENU_TEST_IDS } from '@common/common-test-ids.const'

import type { BaseMobileMenuProps } from './BaseMobileMenu.types'
import { BaseMobileMenuView } from './BaseMobileMenuView'
import { MobileMenuProvider } from './context'
import { useBaseMobileMenu } from './hooks/useBaseMobileMenu'

export type { BaseMobileMenuProps } from './BaseMobileMenu.types'

export function BaseMobileMenu(props: BaseMobileMenuProps) {
  const contextValue = useBaseMobileMenu(props)

  return (
    <div data-testid={MOBILE_MENU_TEST_IDS.shell} style={{ display: 'contents' }}>
      <MobileMenuProvider value={contextValue}>
        <BaseMobileMenuView />
      </MobileMenuProvider>
    </div>
  )
}
